var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { IconBaseSvg } from "../icon-base";
var SearchIcon = function (props) { return (React.createElement(IconBaseSvg, __assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("g", { strokeWidth: "0" },
        React.createElement("path", { d: "M16.2938822,14.5786164 L15.3905089,14.5786164 L15.0703259,14.2698685 C16.1909663,12.9662664 16.8656375,11.2738708 16.8656375,9.43281875 C16.8656375,5.32761578 13.5380217,2 9.43281875,2 C5.32761578,2 2,5.32761578 2,9.43281875 C2,13.5380217 5.32761578,16.8656375 9.43281875,16.8656375 C11.2738708,16.8656375 12.9662664,16.1909663 14.2698685,15.0703259 L14.5786164,15.3905089 L14.5786164,16.2938822 L20.2961692,22 L22,20.2961692 L16.2938822,14.5786164 Z M9.43281875,14.5786164 C6.58547742,14.5786164 4.28702115,12.2801601 4.28702115,9.43281875 C4.28702115,6.58547742 6.58547742,4.28702115 9.43281875,4.28702115 C12.2801601,4.28702115 14.5786164,6.58547742 14.5786164,9.43281875 C14.5786164,12.2801601 12.2801601,14.5786164 9.43281875,14.5786164 Z", id: "path-1" })))); };
export default SearchIcon;
//# sourceMappingURL=SearchIcon.js.map